import buildClickoutEvent from "../buildClickoutEvent";
import sendEvents from "../sendEvents";

export default function trackNewsletter(element: HTMLElement) {
  const Event = buildClickoutEvent(element);
  sendEvents(Event);
}
